export default {
  COMMON__MINUTES: 'm',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Editar',
    BUTTON__DELETE: 'Excluir',
    MESSAGE_STATUS__DELETE: 'Excluir',
    MESSAGE_MENU__DELETE: 'Excluir',
    BUTTON__SAVE: 'Salvar',
    BUTTON__CANCEL: 'Cancelar',
    BUTTON__CLOSE: 'Fechar',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Atualizar',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Atualizar',
    CHANNEL_LIST__TITLE: 'Canal',
    CHANNEL_SETTING__HEADER__TITLE: 'Informação do canal',
    MODAL__USER_LIST__TITLE: 'Membros',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Membros',
    NO_MEMBERS: '(Sem membros)',
    NO_NAME: '(Sem nome)',
    TOOLTIP__UNKOWN_USER: '(Sem nome)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Sair do canal',
    BUTTON__INVITE: 'Convidar',
    MODAL__INVITE_MEMBER__SELECTED: 'Selecionado',
    MODAL__CREATE_CHANNEL__SELECTED: 'Selecionado',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Nome do canal',
    MODAL__INVITE_MEMBER__TITLE: 'Adicionar membros',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Inserir',
    MESSAGE_INPUT__PLACE_HOLDER: 'Inserir',
    BUTTON__CREATE: 'Criar',
    MODAL__CREATE_CHANNEL__TITLE: 'Canal novo',
    TRYING_TO_CONNECT: 'Tentando conectar...',
    USER_PROFILE__MESSAGE: 'Mensagem',
    USER_PROFILE__USER_ID: 'ID do usuário',
    EDIT_PROFILE__USERID_LABEL: 'ID do usuário',
    EDIT_PROFILE__TITLE: 'Meu perfil',
    EDIT_PROFILE__IMAGE_LABEL: 'Imagem de perfil',
    EDIT_PROFILE__NICKNAME_LABEL: 'Apelido',
    EDIT_PROFILE__THEME_LABEL: 'Tema escuro',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'O chat não está disponível neste canal.',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'Novas mensagens de',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'Ativado',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'Todos os membros',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Convidar usuários',
    MODAL__DELETE_MESSAGE__TITLE: 'Você quer excluir esta mensagem?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Editar informações do canal',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Imagem do canal',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Insira o nome.',
    TYPING_INDICATOR__IS_TYPING: 'Digitando...',
    TYPING_INDICATOR__ARE_TYPING: 'Digitando...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'Digitando...',
    TYPING_INDICATOR__AND: 'e',
    MESSAGE_STATUS__SENDING_FAILED: 'Não foi possível enviar a mensagem.',
    MESSAGE_STATUS__TRY_AGAIN: 'Tente novamente',
    MESSAGE_STATUS__OR: 'ou',
    PLACE_HOLDER__WRONG: 'Algo deu errado.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Tentar novamente',
    NO_TITLE: 'Sem título',
    TOOLTIP__AND_YOU: ', e você.',
    TOOLTIP__YOU: 'Você',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Tipo de mensagem desconhecido)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Não foi possível ler esta mensagem.',
    MESSAGE_EDITED: '(editado)',
    PLACE_HOLDER__NO_CHANNEL: 'Iniciar uma nova conversa',
    MESSAGE_MENU__REPLY: 'Responder',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'Você',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Responder a uma mensagem',
    CHANNEL_SETTING__PROFILE__EDIT: 'Editar',
    MESSAGE_MENU__COPY: 'Copiar',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'Aceitar',
  SETTINGS__NONE: 'Nenhum',
  SEARCH__USER_PLACEHOLDER: 'Nome/Número de empregado/Telefone',
  SEARCH__NO_USER_INFO: 'Não há informações do usuário',
  LOGIN__EMAIL_OR_HP: 'E-mail ou número de telefone',
  ELECTRON: {
    MENU_DELETE: 'Excluir',
    MENU_VIEW: 'Ver',
    MENU_SIGN_OUT: 'Sair',
    MENU_SETTINGS: 'Configurações',
    MENU_CLOSE: 'Fechar',
    MENU_SELECT_ALL: 'Selecionar todos',
    MENU_FILE: 'Arquivos',
    MENU_ABOUT: 'Sobre {0}',
    MENU_UPDATE: 'Verificar atualização',
    MENU_HIDE: 'Ocultar {0}',
    MENU_HIDE_OTHERS: 'Ocultar Outros',
    MENU_SHOW_ALL: 'Mostrar tudo',
    MENU_QUIT: 'Finalizar {0}',
    MENU_NEW_CHANNEL: 'Canal novo',
    MENU_UNDO: 'Desfazer',
    MENU_REDO: 'Refazer',
    MENU_CUT: 'Cortar',
    MENU_PASTE: 'Colar',
    MENU_PASTE_AND_MATCH_STYLE: 'Colar Estilo',
    MENU_RELOAD: 'Atualizar',
    MENU_FORCE_RELOAD: 'Atualização forçada',
    MENU_FULL_SCREEN: 'Alternar para tela cheia',
    MENU_RESET_ZOOM: 'Tamanho real',
    MENU_ZOOM_IN: 'Zoom in',
    MENU_ZOOM_OUT: 'Zoom out',
    MENU_WINDOW: 'Janela',
    MENU_MINIMIZE: 'Minimizar ao máximo',
    MENU_ZOOM: 'Maximizar ao máximo',
    MENU_HELP: 'Ajuda',
    MESSAGE_UP_TO_DATE: 'Você está usando a versão mais recente.',
    UPDATE_AVAILABLE: 'Atualização disponível',
    MESSAGE_UPDATE_AVAILABLE: 'Há uma atualização disponível para a versão mais recente.',
    MENU_EDIT: 'Editar',
    MENU_COPY: 'Copiar',
    UP_TO_DATE: 'Última versão',
  },
  LOGIN__INSERT_EMAIL_HP: 'Insira seu e-mail ou número de telefone.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE:
    'Se esqueceu sua senha, tente redefinir sua senha na página de login do aplicativo em seu celular.',
  LOGIN__INSERT_PASSWORD: 'Insira sua senha.',
  LOGIN__PASSWORD_INFORMATION: 'Esqueceu sua senha?',
  BEFORE: 'Antes',
  ALERT__NO_ONE_SELECTED: 'Nenhum funcionário selecionado.',
  BASIC__: {
    ERROR: 'Ocorreu um erro.<br /> Por favor, tente novamente.',
    MSG__: { INPUT: 'Insira sua busca' },
    PWD_ALL_VALIDATION:
      'A senha deve ser uma combinação de %1$@~%2$@ letras maiúsculas/minúsculas, números e caracteres especiais.',
    RETRY: 'Tentar novamente',
    PASSWORD_RULE: '8-20 caracteres e contém letras, números e símbolos.',
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Autorizado para ver o histórico de assiduidade pessoal?',
  },
  LOGOUT: 'Sair',
  COMMON__SECONDS: 'Segundos',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'Se for para edição, as modificações não serão salvas.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Tem certeza de que deseja parar a edição do calendário?',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: 'Nenhum modelo registrado.' } },
  AWAY_TIME: 'h',
  SETTINGS__CHANGE_LANGUAGE: 'Idioma',
  SEARCH__MEMBER_PLACEHOLDER: 'Nome/Nº de funcionário/Telefone',
  ' ': "Se configurar como 'Não usar', a função de gestão de gravidez/pós-parto será desativada e você não poderá ver registros relacionados.",
  BASIC__UNKNOWN: 'Desconhecido',
  LOGIN__SERVER_ALERT: 'Incapaz de conectar ao servidor.',
  MSG__: {
    ERROR__: {
      UPDATE_CHANNEL_INFO: 'Incapaz de atualizar canal.',
      LEAVE_CHANNEL: 'Incapaz de sair do canal.',
      CREATE_CHANNEL: 'Não foi possível criar o canal.',
    },
    FILE__: { MAXIMGSIZE: 'Excede o limite de tamanho de arquivo.' },
    ALLOW_BROWSER_ALARM:
      'Permita notificações nas configurações do seu navegador para receber mensagens de notificação.',
    LABEL__: { SEARCH_MESSAGE: 'Buscar mensagens' },
    GUIDE__: { SEARCH_MESSAGE: 'Busque a mensagem que deseja encontrar em {0}.' },
    BASIC__: { NO_SEARCH_RESULT: 'Nenhum resultado encontrado.' },
  },
  INVITE__MEMBER_SELECTION: 'Escolher membros',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'O nome alterado será visível a todos os participantes do canal.',
  NOTICE: 'Notificações',
  INVITE__CREATE: 'Criar',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Você quer sair do canal?',
  LOGIN__PASSWORD_FAIL_COUNT: 'Você digitou a senha incorreta {0} vezes.',
  LOGIN__FAIL_ALERT: 'Será bloqueado por 5 minutos após 5 tentativas incorretas consecutivas.',
  LOGIN__LOCK_STATE_ALERT: 'Bloqueado por 5 minutos após 5 senhas incorretas consecutivas.',
  LOGIN__RETRY_ALERT: 'Por favor, tente novamente após {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE: 'A senha do ShoplaChat é a mesma que a senha do aplicativo móvel.',
  SETTINGS__ALL_MESSAGES: 'Notificações em todas as novas mensagens',
  SETTINGS__ALARM_SOUND: 'Som',
  SETTINGS__SOUND_ALARM: 'Som de notificação',
  SETTINGS__LISTEN_ALARM_SOUND: 'Ouvir',
  ALERT__MAX_INVITE_MEMBER: 'O número máximo de pessoas que podem entrar no canal é 20.000.',
  LOGIN__DEACTIVATED_ALERT: 'Não é possível fazer login porque o administrador desativou a função de chat.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Não é possível fazer login devido à rede instável. Por favor, verifique sua conexão de rede e tente novamente.',
  LOGIN__LOGOUT_ALERT: 'Você foi desconectado.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Alterar nome do canal',
  SETTINGS__THEME: 'Tópico',
  SETTINGS__LANGUAGE: 'Idioma',
  SETTINGS__LIGHT_THEME: 'Claro',
  SETTINGS__DARK_THEME: 'Escuro',
  SEARCH__CHANNEL_PLACEHOLDER: 'Nome do funcionário',
  CHANNEL__CONTACT: 'Chat 1:1',
  BASIC: { LABEL: { MAXIMAGECNT: 'Até {0} imagens podem ser registradas.' } },
  LOGIN__LOGIN_FAILED: 'ID ou senha estão incorretos.',
  FORGOT_PW: 'Esqueceu sua senha?',
  BASIC__MAX_FORMAT_INPUT: 'É possível inserir caracteres de no máximo %@.',
  SERVICE__COMING_SOON: 'Será fornecido em breve.',
  LOGIN__GUIDE: 'Você pode fazer login com a conta no aplicativo.',
  MOBILE__: {
    ACCESS_PC: 'Acesse o painel a partir do PC!',
    ACCESS_DESC_01: 'O painel está otimizado para o ambiente de PC.',
    ACCESS_DESC_02: 'Tente acessar de um PC para uma experiência mais fluida.',
    ACCESS_PC_ONLY: 'Tente acessar a partir do PC.',
    GUIDE: 'A função de chat está disponível no seu PC ou aplicativo móvel.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'Sem conversas',
  LOGIN: 'Iniciar Sessão',
  LOGIN__PASSWORD: 'Senha',
  SEARCH__NO_RESULT: 'Nenhum resultado encontrado.',
  BASIC__SEARCH: 'Buscar',
};
